import simpleLightbox from 'simplelightbox';
export default class PopupEquipment {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;
        this.root = el;
        this.close = this.root.querySelector('[data-popup-close]');
        this.overlay = this.root.querySelector('[data-popup-overlay]');

        this.galleryInstance = null;

        return true;
    }

    init() {
        this.bindClose();
        this.bindOverlayClose();
        this.setLightbox();
    }

    bindOverlayClose() {
        if (!this.overlay) return;
        this.overlay.addEventListener('click', this.closePopup.bind(this));
    }

    bindClose() {
        if (!this.close) return;
        this.close.addEventListener('click', this.closePopup.bind(this));
    }

    closePopup() {
        this.root.remove();
    }

    setLightbox() {
        const galleries = this.root.querySelectorAll(
            '.gallery-icon a'
        );

        if (this.galleryInstance !== null) this.galleryInstance.destroy();
        if (galleries && galleries.length > 0)
            this.galleryInstance = new simpleLightbox(galleries, {
                closeText: '',
            });
    }
}
